<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'

export default {
  name: 'BuildUserStat',
  props: {
    title: {
      type: String,
      default: ''
    },
    k: {
      type: String,
      default: 'user'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#00BFFF'],
        title: {
          text: this.title
        },
        xAxis: {
          name: '类型',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 65
          }
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '数量',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
    },
    refresh(data, cardInfo) {
      const time = []
      const stat = []
      for (const i in data) {
        const val = data[i]
        time.push(cardInfo[val.card_id])
        stat.push(val.card_num)
      }
      this.option.xAxis.data = time
      this.option.series[0].data = stat
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
